import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.string.includes.js";
import store from '@/store';
import { includeArray } from '@/libs/system';
export default (function (value) {
  if (value === undefined) return true;
  var access = store.state.admin.user.info.access;
  var isPermission = false;
  if (value && value instanceof Array && value.length && access && access.length) {
    isPermission = includeArray(value, access) || access.includes("admin");
  }
  return isPermission;
});